import { haptic } from '../telegram/haptic';

export function Segmented<T extends string>({
  value,
  options,
  onChange,
}: {
  value: T;
  options: { value: T; label: string }[];
  onChange: (v: T) => void;
}) {
  return (
    <div role="radiogroup" className="flex rounded-xl bg-secondary-bg p-1">
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => {
              if (!active) {
                haptic.select();
                onChange(o.value);
              }
            }}
            className={`flex-1 rounded-lg px-3 py-2 text-sm font-medium transition ${
              active ? 'bg-bg shadow-sm' : 'text-hint'
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
